import { Box, Container, Grid, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import PaymentIcon from '@mui/icons-material/Payment';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { services } from '../services/api';
import Swal from "sweetalert2";

const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText('#005cbf'),
    backgroundColor: '#606770',
    '&:hover': {
        backgroundColor: '#606770',
    },
}));

const ColorButtonSecond = styled(Button)(({ theme }) => ({
    color: '#606770',
    backgroundColor: '#ffc3d0',
    border: 'none',
    '&:hover': {
        transform: 'scale(1.005)',
        boxShadow: '3px 3px 6px 0px rgba(0, 0, 0, 0.2)',
    },
}));

const PagoLineaPublic = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let code = new URLSearchParams(search);
    let lcaptura = code.get('lcaptura');

    if (lcaptura && lcaptura.includes(' ')) {
        lcaptura = lcaptura.replace(/ /g, '+');
    }

    const [state, setState] = useState({});
    const [, setFetching] = useState(true);
    const [loadingPdf, setLoadingPdf] = useState(true);

    const consultaInfo = async () => {
        if (!lcaptura) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "No se proporcionó una línea de captura válida.",
            });
            setFetching(false);
            navigate("/")
            return;
        }

        try {
            setFetching(true);
            const lcapturaSegura = encodeURIComponent(lcaptura);
            const consultaLinea = await services('GET', `linea-captura/detalles-inscripcion?lcaptura=${lcapturaSegura}`);

            if (consultaLinea.status === 200) {
                const responseData = consultaLinea.data.data || consultaLinea.data;
                setState(responseData);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: consultaLinea?.data?.message || "Orden de pago no encontrada.",
                });
                navigate("/")
            }
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al obtener la información del pago.",
            });
        } finally {
            setFetching(false);
        }
    }

    useEffect(() => {
        consultaInfo();
        // eslint-disable-next-line
    }, [lcaptura]);

    const {
        conceptoplinea = "",
        fechaplinea = "",
        formato = "",
        importe = "",
        linea_captura = "",
        token = "",
    } = state;

    const currentStatus = state.status ? state.status : (state.estatus ? state.estatus : "pendiente");

    const pdfFake = '';

    const regresar = () => {
        navigate("/");
    };

    return (
        <div className='h-100'>
            <Container maxWidth="md">
                <Box sx={{ height: 'auto', paddingTop: '6%' }}>
                    <Box>
                        <Grid container spacing={1} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs="auto">
                                <ColorButtonSecond variant="outlined" onClick={regresar} endIcon={<KeyboardReturnIcon />}>
                                    IR A INICIO
                                </ColorButtonSecond>
                            </Grid>

                            <Grid item xs="auto">
                                <a rel="noreferrer" target='_blank' href={formato ? `${formato}/2` : pdfFake}>
                                    <ColorButtonSecond variant="outlined" endIcon={<CloudDownloadIcon />}>
                                        {currentStatus === "pendiente" || currentStatus === "vencido" ? "Descargar mi formato de pago" : "Descargar comprobante de pago"}
                                    </ColorButtonSecond>
                                </a>
                            </Grid>

                            <Grid item xs="auto">
                                <form action={process.env.REACT_APP_URLPAGO} method="post">
                                    <input type="hidden" name="concepto" value={conceptoplinea} />
                                    <input type="hidden" name="lcaptura" value={linea_captura} />
                                    <input type="hidden" name="monto" value={importe} />
                                    <input type="hidden" name="fecha_vencimiento" value={fechaplinea} />
                                    <input type="hidden" name="tkn" value={token} />
                                    <input type="hidden" name="urlRetorno" value={process.env.REACT_APP_URLREDIRECT} />
                                    <input type="hidden" name="email" value="" />

                                    {currentStatus === "pendiente" &&
                                        <ColorButton variant="outlined" type='submit' endIcon={<PaymentIcon />}>
                                            Pagar en Línea
                                        </ColorButton>
                                    }
                                </form>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                <div className='pt-2 border-bottom--guinda text-big mb-2 text-bold'>
                    {currentStatus === "pendiente" ? "Formato de pago" : "Comprobante de Pago"}
                </div>

                <div className="d-flex justify-content-center align-items-center pt-3 pb-3" style={{ position: "relative", height: "80vh", width: "100%" }}>
                    {loadingPdf && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                                width: "100%",
                                height: "100%",
                            }}
                        >
                            <span className="loader"></span>
                        </div>
                    )}

                    {formato ? (
                        <object
                            data={formato}
                            type="application/pdf"
                            className="responsive-pdf"
                            title="PDF Preview"
                            height="100%"
                            width="100%"
                            onLoad={() => setLoadingPdf(false)}
                        >
                            <p>Hubo un error al mostrar el PDF. Da clic <a href={formato}>aquí</a> para descargar tu formato.</p>
                        </object>
                    ) : (
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            width: "100%",
                            height: "100%",
                        }} />
                    )}
                </div>
            </Container>
        </div>
    )
}

export default PagoLineaPublic;